import { render, staticRenderFns } from "./AdzImage.vue?vue&type=template&id=412ce75c&scoped=true&"
import script from "./AdzImage.vue?vue&type=script&lang=js&"
export * from "./AdzImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ce75c",
  null
  
)

export default component.exports